module.exports = __webpack_public_path__ + "media/Valut Opening.1aa2d923.mp3";